import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { InputStyled, type InputStyledProps, TooltipStyled } from "@/components/atoms";
import { QuestionIcon, RepeatIcon } from "@/components/icons";

type Props = {
  title?: string;
  tooltipText?: string;
  customTooltip?: React.ReactNode;
  helperText?: string;
  errorText?: string;
  value?: string | number;
  defaultValue?: string | number;
  copyButton?: boolean;
  onCopy?: () => void;
  copyValue?: string | number;
} & InputStyledProps;

export const FormInput = React.memo(function FormInput(props: Props) {
  const {
    title,
    tooltipText,
    helperText,
    errorText,
    copyButton,
    onCopy,
    copyValue,
    customTooltip,
    ...rest
  } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const onCopyValue = React.useCallback(() => {
    onCopy?.();
    if (!inputRef.current) {
      return;
    }

    inputRef.current.value = copyValue ? copyValue.toString() : "";
  }, [copyValue, onCopy]);

  return (
    <FormControl isInvalid={Boolean(errorText)} flexBasis={"32%"} flexGrow={1} minW={"195px"}>
      <FormLabel display={"flex"} gap={1} alignItems={"center"}>
        <Text variant={"text_xs_normal"} fontSize={"14px"}>
          {title}
        </Text>
        {tooltipText && (
          <TooltipStyled tooltipText={tooltipText}>
            <QuestionIcon size="m" />
          </TooltipStyled>
        )}
        {customTooltip}
      </FormLabel>
      <InputStyled
        ref={inputRef}
        rightElement={
          copyButton ? (
            <InputRightElement h="100%" w="auto" px="5px" opacity={0.8}>
              <button onClick={onCopyValue}>
                <RepeatIcon w={18} h={18} />
              </button>
            </InputRightElement>
          ) : undefined
        }
        groupProps={{ width: "100%" }}
        {...rest}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {errorText && <FormErrorMessage>{errorText}</FormErrorMessage>}
    </FormControl>
  );
});
